var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "sort-panel"
  }, [_c('el-popover', {
    attrs: {
      "width": _vm.popWidth,
      "placement": _vm.placement,
      "visible-arrow": false,
      "title": "",
      "trigger": "click"
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "sort-items"
  }, [_c('sort-list', {
    attrs: {
      "items": _vm.tempData,
      "col": _vm.col
    },
    on: {
      "change": _vm.onChange
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._t("default", function () {
    return [_c('el-button', {
      attrs: {
        "type": "default",
        "icon": "el-icon-s-operation",
        "size": "small"
      }
    }, [_vm._v(" " + _vm._s(_vm.title) + " ")])];
  })], 2)])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };